module.exports = {
          srcSet: __webpack_public_path__ + "ba76f02be774277fad6cd55e26cb832a-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "ba76f02be774277fad6cd55e26cb832a-180.png",width: 180,height: 50}],
          src: __webpack_public_path__ + "ba76f02be774277fad6cd55e26cb832a-180.png",
          toString:function(){return __webpack_public_path__ + "ba76f02be774277fad6cd55e26cb832a-180.png"},
          
          width: 180,
          height: 50
        }